<template>
    <div>
        <h5 v-if="Pagos && !mostrarDevoluciones">Pagos encontrados</h5>
        
        <h5 v-if="mostrarDevoluciones">Devoluciones Registradas</h5>
        <hr />


        <div v-if="BotonRegresar"  class="pb-1">
          <button class="btn btn-primary overwrapDeBotones mb-1 p-2" @click='Regresar()'><i class="fas fa-arrow-circle-left"></i></button>
        </div>


        <div class="table-responsive"><!-- agregar estilo en el chido de ser necesario style="overflow: hidden;"-->
            <!-- class="table-responsive" -->

        <!--Pagos-->
        <table v-if="Pagos" :key="'TablaPagos'" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDePagos_table"
                data-search="false" 
                data-toggle="tablaDePagos_table" 
                data-pagination="true" 
                data-toolbar="#tablaDePagos_texto_div"
                data-page-size="5"
                data-page-list="[5,10,15, all]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">No. Folio</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Juzgado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Materia</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Consecutivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Tipo de documento</th>                                       
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Nombre</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Concepto</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Monto</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Observaciones</th>
                    <th v-if="AccionesMostrar" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
                <template>
                    <tr v-for="(pago, indexP) in Pagos" :key="'Imputado' + pago.RubroID + indexP">
                        <td class="text-center align-middle" style="width:5%;">{{ pago.Folio }}</td>
                        <td class="text-center align-middle" style="width:15%;">{{ pago.Expediente.Area.Nombre }}</td>
                        <!-- <td class="text-center align-middle" style="width:10%;">{{ pago.Expediente.Materia.Nombre }}</td> -->
                        <td class="text-center align-middle" style="width:9%;">{{((pago.Expediente.Consecutivo != null) ? pago.Expediente.Consecutivo : '') +  ((pago.Expediente.NumeroRomano != null) ? '-' + pago.Expediente.NumeroRomano : '')
                        }}</td>
                        <td class="text-center align-middle" style="width:9%;">{{ pago.Expediente.TipoDocumento.Nombre }}</td>
                        <td class="text-center align-middle" style="width:20%;">{{ pago.Nombre + ' ' +  ((pago.ApellidoPaterno != null) ? pago.ApellidoPaterno : '') + ' ' + ((pago.ApellidoMaterno != null) ?  pago.ApellidoMaterno : '') }}</td>
                        <td class="text-center align-middle" style="width:9%;">{{ pago.RubroDBPJ.Nombre }}</td>
                        <td class="text-center align-middle" style="width:15%;">{{ '$' + agregarCeros(pago.Monto) }}</td>
                        <td class="text-center align-middle" >{{pago.Observaciones}}</td>
                        <td v-if="AccionesMostrar" class="text-center align-middle" style="width:20%;">
                            <!-- <i class="fa-regular fa-address-card fa-lg pl-1 pr-1 iconoHabilitado" @click="limpiarAccionesParaPadre(); eventoValorParaElPadre(indexImp,RutaOficioRubro)"></i>-->
                            <!-- <i class="fas fa-credit-card fa-lg" title="Registrar Pago"></i> --> 
                            <div class="d-flex column justify-content-between"> 
                            
                            <i v-if="!Inhabilitar 
                                  && !Devolver 
                                  && (pago.Impreso || (FechaDDMMAAAA(pago.FechaDePago) == new Date().toLocaleDateString('en-GB') && pago.Folio == ultimoFolio))
                                  " class="fas fa-print fa-2x" title="Imprimir Recibo" @click="imprimirRecibo(pago.Folio)">
                            </i>

                            <i v-if="!pago.Impreso 
                                  && !Inhabilitar 
                                  && !Devolver
                                  && (FechaDDMMAAAA(pago.FechaDePago) == new Date().toLocaleDateString('en-GB'))
                                  && pago.Folio == ultimoFolio" class="fas fa-edit fa-2x" style="margin-left: 5px;" title="Editar Pago" @click="editarPago(pago.RubroId)">
                            </i>

                            <i v-if="!Inhabilitar 
                                  && !Devolver 
                                  && (FechaDDMMAAAA(pago.FechaDePago) < new Date().toLocaleDateString('en-GB')
                                    || pago.Folio != ultimoFolio)

                                  && !pago.Impreso ">
                                Favor de Cancelar Pago 
                            </i>

                            <i v-if="!pago.Impreso 
                                  && !Inhabilitar
                                  && !Devolver 
                                  && (FechaDDMMAAAA(pago.FechaDePago) == new Date().toLocaleDateString('en-GB'))
                                  && pago.Folio == ultimoFolio" class="fas fa-plus fa-2x" style="margin-left: 5px;" title="Agregar Rubro" @click="agregarRubro(pago.RubroId)">
                                
                            </i>

                            <i v-if="Inhabilitar" class="fas fa-window-close fa-2x" style="margin-left: 5px; margin-right: 10px;" title="Inhabilitar Recibo" @click="inhabilitarPago(pago.Folio)"></i>
                            
                            <i v-if="Devolver && sumarDevoluciones(pago) < pago.Monto" class="fas fa-wallet fa-2x" style="margin-left: 5px; margin-right: 10px;" title="Registrar Devolucion" @click="devolverPago(pago.RubroId, sumarDevoluciones(pago))"></i>
                            <i v-if="Devolver && pago.Devoluciones.length > 0" class="fas fa-list fa-2x" style="margin-left: 5px; margin-right: 10px;" title="Mostrar Devoluciones Registradas" @click="mostrarDevolucionesRegistradas(pago)"></i>
                            </div>
                                           
                            <!-- <i v-bind:class="[pago.RutaOficioRubro ? 'iconoHabilitado': 'iconoDeshabilitado','fas fa-eye fa-lg p-1']" @click="limpiarAccionesParaPadre(); eventoValorParaElPadre(indexImp,indexP)"></i> -->
                            
                        </td>
                    </tr>
                </template>    
               
            </tbody>
        </table>
        <div v-if="mostrarDevoluciones" style="text-align: auto;">
            <h5>Datos del Rubro</h5>
            <p>
                Folio: {{datosDevolucion.Folio}}<br>
                Monto Total del rubro: {{'$' + agregarCeros(datosDevolucion.Monto)}}<br>
                Total devuelto: {{'$' + ((!total) ?  0 : agregarCeros(total))}}<br>
                {{primeraLetraMayuscula(datosDevolucion.Expediente.TipoDocumento.Nombre) + ': '}}{{((datosDevolucion.Expediente.Consecutivo != null) ? datosDevolucion.Expediente.Consecutivo : '') +  ((datosDevolucion.Expediente.NumeroRomano != null) ? '-' + datosDevolucion.Expediente.NumeroRomano : '')
                }}<br>
                Concepto: {{datosDevolucion.RubroDBPJ.Nombre}}
            </p>
        </div>
        <table v-if="mostrarDevoluciones" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeDevoluciones_table"
                data-search="false" 
                data-toggle="tablaDeDevoluciones_table" 
                data-pagination="true" 
                data-toolbar="#tablaDeDevoluciones_texto_div"
                data-page-size="5"
                data-page-list="[5,10,15, all]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">                                
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Remitente</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Destinatario</th>                                  
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">No. Oficio Juzgado</th> 
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">No. Cheque</th> 
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">No. Oficio Oficialia</th>        
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">A Nombre De</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Banco</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Monto registrado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Estatus</th>
                    <th v-if="AccionesMostrar" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" class="text-center">Acciones</th>
            </thead>
            <tbody>
                    <tr v-for="(devolucion, indexDev) in datosDevolucion.Devoluciones" :key="indexDev">
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.TituloRemitente.Nombre + ' ' + devolucion.NombreRemitente}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.TituloDestinatario.Nombre + ' ' + devolucion.NombreDestinatario}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.NumeroOficioJuzgado}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.NumeroCheque}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.NumeroOficioOficialia}} </td>
                        <td class="text-center align-middle" style="width:20%;">{{devolucion.Persona.Nombre + ' ' +  ((devolucion.Persona.ApellidoPaterno != null) ? devolucion.Persona.ApellidoPaterno : '') + ' ' + ((devolucion.Persona.ApellidoMaterno != null) ?  devolucion.Persona.ApellidoMaterno : '') }}</td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.TipoBanco.Nombre}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{'$' + agregarCeros(devolucion.MontoDevolucion)}} </td>
                        <td class="text-center align-middle" style="width:9%;"> {{devolucion.TipoEstatusDevolucion.Nombre}}</td>

                        <td class="text-center align-middle" style="width:9%;">
                        <i v-if="Devolver && (!(devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId == 1) || datosDevolucion.Monto > total)" class="fas fa-print fa-2x" title="Imprimir Recibo" @click="imprimirDevolucion(devolucion)"></i>
                        <i v-if="Devolver && devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId == 1 && datosDevolucion.Monto > total" class="fas fa-sync fa-2x" title="Actualizar Estatus Devolucion" @click="cambiarEstatusDevolucion(devolucion)"></i>
                        <i v-if="Devolver && devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId == 1 && datosDevolucion.Monto > total" class="fas fa-edit fa-2x" title="Editar Devolucion" @click="editarDevolucion(devolucion.DevolucionId); "></i>
                        <i v-if="Devolver && devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId == 1" class="fas fa-eraser fa-2x" title="Borrar Devolucion Registrada" @click="eliminarDevolucion(devolucion.DevolucionId, devolucion.MontoDevolucion, datosDevolucion.Folio)"></i>
                        </td>
                    </tr>
            </tbody>
        </table>
        </div>
        <hr />
    </div>
</template>
<script>
    import Vue from 'vue'
    import comun from "@/../static/js/comun"
    import enumeraciones from '@/../static/js/enumeraciones'
    import catalogos from '@/../static/js/catalogos'
    import moment from 'moment'
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
    
    import func from './Funciones/comun.js'

    export default {
        data() {
            return {
                enumeraciones,
                textoVisorDehabilitado:"El archivo no existe.",
                informacionParaPadre: {
                    Pagos:Object,
                    Accion:
                    {
                    }
                    ,
                    accionRealizar: Function
                },
                mostrarDevoluciones : false,
                datosDevolucion: null,
                datosPago: null,
                totalDevuelto: null,
                diferenciaTotal: null,
                contRenderPagos: 4,
                //pagosTabla: null,
            }
        },
        directives: {
            tooltipF
        },
        props: {
            AccionesMostrar:{
            },
            Imputados: {},
            Pagos: {},
            Inhabilitar : Boolean,
            Devolver : Boolean,
            BotonRegresar:{},
            Regresar: Function,
            ultimoFolio: 0,
        },
        mounted() { 
            this.$nextTick(()=> { PaginarTabla('tablaDePagos_table', 5)});
        },
        created() {

        },
        computed:{
            total(){//ir sumando cada monto si es que es estatus > 1
                this.$parent.quitarMenuEstatus();

                if(document.getElementById('navtablaDePagos_table')){
                    document.getElementById('navtablaDePagos_table').addEventListener('click', (e)=>{//oculta devoluciones al cambiar de pagina
                        if(e.target !== e.currentTarget){
                            this.mostrarDevoluciones = false;
                            this.$parent.quitarMenuEstatus();
                        }
                    });
                }

                
                if(this.datosDevolucion){
                    return this.datosDevolucion.Devoluciones.reduce((sum, Pagos)=>{
                        return (Pagos.TipoEstatusDevolucion.TipoEstatusDevolucionId > 1) ? sum + Pagos.MontoDevolucion : sum
                    }, 0)
                }
            },
        },
        watch:{
            Pagos:{
                handler: function(nuevo, viejo){
                    //this.contRenderPagos += 4;
                },
                deep: true,
                immediate: true,
            }
        },
        methods: {            
            /**
             * Método encargado de limpiar acciones que que transfieren al padre para realizar una acción.
             */
            limpiarAccionesParaPadre:function()
            {
                this.informacionParaPadre.Accion = {                    
                }
            },
            /**
             * Método encargado de enviar la información necesaria para trabajar a componente padre, se manda
             * un objeto imputado, así como la acción a realizar.
             */
            eventoValorParaElPadre:function(indexDeElementoPadre, indexDeElemento)
            {
                if(indexDeElemento > -1) 
                {
                    this.informacionParaPadre.Imputados = this.Imputados[indexDeElementoPadre];                   
                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre);
                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },

            accionRealizar:function(){

            },

            editarPago : function(rubroId){//////***editar pago
                this.$emit("editarPago", rubroId);
            },

            agregarRubro : function(rubroId){
                this.$emit("agregarRubro", rubroId);
            },

            inhabilitarPago : function(folio){
                this.$emit("inhabilitarPago", folio)
            },

            devolverPago : function(rubroId, devuelto){
                this.$emit("devolverPago", rubroId, devuelto)
            },

            imprimirRecibo : function(folio) {
                this.$emit("imprimirRecibo", folio);
            },

            agregarCeros : function(monto){
                return func.agregarCeros(monto)
            },
            FechaDDMMAAAA : function(fecha){
                return func.FechaDDMMAAAA(fecha)
            },

            imprimirDevolucion : function(devolucion){
                this.$emit("imprimirDevolucion", devolucion, this.datosDevolucion)
            },

            eliminarDevolucion : function(devolucionId, monto, folio){
                this.$emit("eliminarDevolucion", devolucionId, monto, folio)
            },

            editarDevolucion : function(devolucion){
                this.$emit("editarDevolucion", devolucion, this.datosDevolucion.RubroId, this.total)
            },

            mostrarDevolucionesRegistradas : function(pago){   
                this.mostrarDevoluciones = true;
                this.totalDevuelto = this.sumarDevoluciones(pago);
                this.datosDevolucion = pago; 
            },
            sumarDevoluciones : function(pago){
                var suma = 0;
                pago.Devoluciones.forEach((devolucion)=>{
                    if(devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId > 1)
                    suma += devolucion.MontoDevolucion
                })
                return suma
            },
            cambiarEstatusDevolucion :function(devolucion){
                this.diferenciaTotal = parseFloat((this.totalDevuelto + devolucion.MontoDevolucion).toFixed(2))

                if(this.diferenciaTotal > this.datosDevolucion.Monto){
                    comun.mensajeDeAlerta("El monto registrado excede el total del rubro, favor de editar o eliminar la devolucion", null, null);
                }
                else{
                    this.$emit("cambiarEstatusDevolucion", devolucion, this.datosDevolucion)
                }
            },
            primeraLetraMayuscula: function(frase){
                return func.primeraLetraMayuscula(frase)
            }

        }
    }
</script>

<style scoped>
    #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
    }

    .iconoDeshabilitado
    {
        cursor: not-allowed;
        opacity: 0.4;
    }
    .iconoHabilitado{
        cursor: pointer;
    }
    .altoDeTablaFijo
    {
        max-height:80vh;
    }
    .altoDeTablaFijo thead th {
        position: sticky;
        top: 0;
    }
    .thead-green{
        background-color: var(--verde-pj-100);
    }
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Comun/TablaDeResultados.vue